// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"TextErrorMessage_errorMessage__jTC1n"};